import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxSplitViewComponent } from './rx-split-view.component';

@NgModule({
  imports: [CommonModule, RxSplitViewComponent],
  exports: [RxSplitViewComponent],
})
export class RxSplitViewModule {}
